import React, { useState } from 'react';
import { Button, Modal, Form, DatePicker, useToaster, Message } from 'rsuite';
import { useTranslation } from 'react-i18next';

const ConfirmModal = ({ confirmDialog, setConfirmDialog }) => {
  const { t } = useTranslation();
  const toaster = useToaster();
  const [resignationDate, setResignationDate] = useState(null);

  const renderSubtitle = () => {
    if (
      typeof confirmDialog.subtitle === 'string' ||
      React.isValidElement(confirmDialog.subtitle)
    ) {
      return confirmDialog.subtitle;
    }
    return (
      <div style={{ lineHeight: '1.5', marginBottom: 10 }}>
        {t('Are you sure you want to block this user?')}
        <Form fluid key={`datepicker-${confirmDialog.id || 'modal'}`}>
          <Form.Group>
            <Form.ControlLabel style={{ marginTop: '10px', marginBottom: '10px' }}>
              {t('Resignation Date')}:
            </Form.ControlLabel>
            <DatePicker
              format="dd-MM-yyyy"
              placement="auto"
              value={resignationDate}
              onChange={value => {
                console.log('DatePicker changed:', value);
                setResignationDate(value);
              }}
              style={{ width: 200 }}
              oneTap
              cleanable
              key={`datepicker-${confirmDialog.id || 'modal'}`}
            />
          </Form.Group>
        </Form>
      </div>
    );
  };

  const handleConfirm = () => {
    if (confirmDialog.subtitle === true && !resignationDate) {
      toaster.push(
        <Message type="error" duration={5000} showIcon>
          {t('Please select a resignation date.')}
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    }
    confirmDialog.onConfirm(resignationDate);
  };

  return (
    <Modal
      open={confirmDialog.open}
      onClose={() => {
        setConfirmDialog({ open: false, title: '', subtitle: '', id: '' });
        setResignationDate(null);
      }}
    >
      <Modal.Header>
        <Modal.Title>{confirmDialog.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{renderSubtitle()}</Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => {
            setConfirmDialog({ open: false, title: '', subtitle: '', id: '' });
            setResignationDate(null);
          }}
          appearance="subtle"
        >
          {t('Cancel')}
        </Button>
        <Button onClick={handleConfirm} appearance="primary" loading={confirmDialog.loading}>
          {t('Confirm')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
